import { useQuery } from '@apollo/client';

import errorMessages from 'common/errors/locales';
import getErrorMessageIfPossible from 'common/hooks/useErrorHandledMutation/getErrorMessageIfPossible';
import useToast from 'components/ToastProvider/useToast';

import { ReceiptPreviewDocument } from './graphql/receiptPreview.gql';

interface Parameters {
  receiptId: string;
}

export const useReceiptPreviewQuery = ({ receiptId }: Parameters) => {
  const { showToast } = useToast();

  // We can rely on "cache-first" fetching as the receipt URLs are static
  const { data, ...rest } = useQuery(ReceiptPreviewDocument, {
    onError: (error) =>
      showToast({
        message:
          getErrorMessageIfPossible({ error }) ||
          errorMessages.localizedUnknownError,
        type: 'error',
      }),
    variables: { receiptId },
  });

  return {
    receipt: data?.receipt,
    ...rest,
  };
};

export type ReceiptPreview = NonNullable<
  NonNullable<ReturnType<typeof useReceiptPreviewQuery>>['receipt']
>;
